var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import MaterialDrawer from "@mui/material/Drawer";
import DrawerHeader from "./DrawerHeader";
import DrawerItem from "./DrawerItem";
import DrawerContent from "./DrawerContent";
import DrawerLanguages from "./DrawerLanguages";
import DrawerAvatar from "./DrawerAvatar";
import DrawerFooter from "./DrawerFooter";
// styles
import "./drawer.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawer",
};
const Drawer = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    const classList = classNames("tecma-drawer", className);
    return (_jsx(MaterialDrawer, Object.assign({ className: classList }, rest, { children: children })));
};
Drawer.defaultProps = defaultProps;
const DrawerComponent = Object.assign(Drawer, {
    Header: DrawerHeader,
    Item: DrawerItem,
    Content: DrawerContent,
    Languages: DrawerLanguages,
    Avatar: DrawerAvatar,
    Footer: DrawerFooter,
});
export { DrawerComponent as Drawer };
